import React, { useContext } from 'react';
import { Text } from 'components/typography/Text';
import { Image } from 'semantic-ui-react';
import userSrc from 'assets/media/user.png';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { USER_PERMISSIONS_BY_EMAIL, useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import classNames from 'classnames';
import { useModal } from 'store/modals';
import { useIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import { UserAdministrationModalContext } from '../../../../../../UserAdministrationModalContext';
import { discardChanges } from '../../../../../User/components/discardChanges';
import styles from './styles.module.scss';

export const UserItem = ({ user }) => {

  const userAdministrationModal = useContext(UserAdministrationModalContext);
  const { checkPermissionsByEmail } = useUserPermissionsByEmail(userAdministrationModal.selectedUser?.email);
  const canReadAdminAddress = checkPermissionsByEmail('admin-address', 'read');
  const modal = useModal();
  const intl = useIntl();

  const queryClient = useQueryClient();
  const onUserClick = () => {
    discardChanges(user, canReadAdminAddress, intl, userAdministrationModal, modal);
    queryClient.invalidateQueries([USER_PERMISSIONS_BY_EMAIL, user?.email]);
  };
  const classNameByUserStatus = user?.disabled ? classNames(styles.userCard, styles.disabled) : styles.userCard;

  return (
    <div
      className={classNameByUserStatus}
      onClick={onUserClick}
    >
      <div className={styles.details}>
        <Image
          className={styles.img}
          id="user-avatar"
          alt="user-avatar"
          src={userSrc}
          size="tiny"
          circular
        />

        <Text
          size={14}
          uppercase
        >
          {user.firstName} {user.lastName}
        </Text>
      </div>

      <ShouldRender condition={userAdministrationModal.selectedUser && userAdministrationModal.selectedUser.id === user.id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
